module.exports = __webpack_public_path__ + "img/completion2.343b27b1.svg";